import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRecalculateComputedKpisInPortfolioMutation, useGetAccountQuery } from '~/types/types';
import { downloadCSV } from '~/functions/export';
export default /*#__PURE__*/_defineComponent({
  __name: 'RecalculateKpiValues',
  props: {
    portfolioId: null
  },
  emits: ['reload'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useGetAccountQuery = useGetAccountQuery({
        id: props.portfolioId
      }),
      result = _useGetAccountQuery.result;
    var portfolioName = computed(function () {
      var _result$value, _result$value$getAcco;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount) === null || _result$value$getAcco === void 0 ? void 0 : _result$value$getAcco.name;
    });
    var _useRecalculateComput = useRecalculateComputedKpisInPortfolioMutation(),
      recalculateComputedKpisInPortfolio = _useRecalculateComput.mutate,
      loading = _useRecalculateComput.loading;
    var handleRecalculate = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _result$data;
        var result, csvBinary;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recalculateComputedKpisInPortfolio({
                portfolioId: props.portfolioId
              });
            case 2:
              result = _context.sent;
              csvBinary = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.recalculateComputedKpisInPortfolio;
              if (csvBinary) {
                downloadCSV(csvBinary, "Recalculated KPIs - ".concat(portfolioName.value, ".csv"));
                emit('reload');
              }
              if (csvBinary === '') {
                window.$nuxt.$emit('userMsg', {
                  color: 'green',
                  message: 'No KPI values were changed after recalculation.'
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleRecalculate() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      emit: emit,
      props: props,
      result: result,
      portfolioName: portfolioName,
      recalculateComputedKpisInPortfolio: recalculateComputedKpisInPortfolio,
      loading: loading,
      handleRecalculate: handleRecalculate
    };
  }
});